import ApiService from '../services/api';

export type VehicleHistoryOccurrence = {
    uuid: string;
    protocolNumber?: string | null;
    source?: string | null;
    occurrenceType?: string | null;
    subject?: string | null;
    customer?: string | null;
    status?: string | null;
    currentStep?: string | null;
    finished?: boolean | null;
    createdAt?: string | null;
    createdBy?: string | null;
    vehicle?: { chassis?: string | null; licensePlate?: string | null; odometer?: number | null } | null;
    dispatches?: VehicleHistoryDispatch[] | null;
};

export type VehicleHistoryDispatch = {
    uuid?: string | null;
    type?: string | null;
    status?: string | null;
    payer?: string | null;
    authorizePayment?: boolean | null;
    destinationLocation?: string | null;
};

export type VehicleHistoryBudgetVersion = {
    versionNumber: number;
    statusLabel?: string | null;
    originLabel?: string | null;
    originUserName?: string | null;
    createdAt?: string | null;
};

export type VehicleHistoryBudget = {
    uuid: string;
    number?: string | null;
};

// Usuários da fábrica (AEG) consultam como TOWER, que enxerga ocorrências de qualquer conta.
const OCCURRENCE_PERSONA = 'TOWER';
const PAGE_SIZE = 50;

export const fetchOccurrencesByChassisForHistory = async (chassis: string): Promise<VehicleHistoryOccurrence[]> => {
    const apiService = new ApiService();
    const params = new URLSearchParams({
        page: '0',
        size: String(PAGE_SIZE),
        searchFieldName: 'CHASSIS',
        searchFieldValue: chassis,
    });

    const response = await apiService.post<{ occurrences?: VehicleHistoryOccurrence[] }>(
        `/occurrence/list/${OCCURRENCE_PERSONA}/all?${params.toString()}`,
        {}
    );

    return response.data?.occurrences ?? [];
};

// Rotas v2 de orçamento (feat/budget-v2 do back): paginação 1-indexed.
export const fetchBudgetsByChassis = async (chassis: string): Promise<VehicleHistoryBudget[]> => {
    const apiService = new ApiService(undefined, 'v2');
    const response = await apiService.get<{ content?: VehicleHistoryBudget[] }>('/budgets', {
        params: { chassis, page: 1, limit: PAGE_SIZE },
    });

    return response.data?.content ?? [];
};

export const fetchBudgetVersions = async (budgetUuid: string): Promise<VehicleHistoryBudgetVersion[]> => {
    const apiService = new ApiService(undefined, 'v2');
    const response = await apiService.get<VehicleHistoryBudgetVersion[]>(`/budgets/${budgetUuid}/versions`);

    return response.data ?? [];
};
